export var PreferredNameEnum;
(function (PreferredNameEnum) {
    PreferredNameEnum[PreferredNameEnum["\u30D5\u30EB\u30CD\u30FC\u30E0"] = 1] = "\u30D5\u30EB\u30CD\u30FC\u30E0";
    PreferredNameEnum[PreferredNameEnum["\u3081\u3044"] = 2] = "\u3081\u3044";
    PreferredNameEnum[PreferredNameEnum["\u305B\u3044"] = 3] = "\u305B\u3044";
})(PreferredNameEnum || (PreferredNameEnum = {}));
export var GenderEnum;
(function (GenderEnum) {
    GenderEnum[GenderEnum["\u672A\u767B\u9332"] = 0] = "\u672A\u767B\u9332";
    GenderEnum[GenderEnum["\u7537\u6027"] = 1] = "\u7537\u6027";
    GenderEnum[GenderEnum["\u5973\u6027"] = 2] = "\u5973\u6027";
    GenderEnum[GenderEnum["\u8A00\u3044\u305F\u304F\u3042\u308A\u307E\u305B\u3093"] = 3] = "\u8A00\u3044\u305F\u304F\u3042\u308A\u307E\u305B\u3093";
    GenderEnum[GenderEnum["\u305D\u306E\u4ED6"] = 9] = "\u305D\u306E\u4ED6";
})(GenderEnum || (GenderEnum = {}));
export var PurposeEnum;
(function (PurposeEnum) {
    PurposeEnum[PurposeEnum["\u82E5\u3044\u4EBA\u3068\u306E\u4F1A\u8A71\u3092\u697D\u3057\u307F\u305F\u3044"] = 1] = "\u82E5\u3044\u4EBA\u3068\u306E\u4F1A\u8A71\u3092\u697D\u3057\u307F\u305F\u3044";
    PurposeEnum[PurposeEnum["\u82E5\u3044\u4E16\u4EE3\u306B\u8CA2\u732E\u3057\u305F\u3044"] = 2] = "\u82E5\u3044\u4E16\u4EE3\u306B\u8CA2\u732E\u3057\u305F\u3044";
    PurposeEnum[PurposeEnum["\u4ED5\u4E8B\u3084\u65E5\u5E38\u306E\u7D4C\u9A13\u3092\u4F1D\u3048\u305F\u3044"] = 3] = "\u4ED5\u4E8B\u3084\u65E5\u5E38\u306E\u7D4C\u9A13\u3092\u4F1D\u3048\u305F\u3044";
    PurposeEnum[PurposeEnum["\u65E5\u672C\u8A9E\u3092\u6559\u3048\u305F\u3044"] = 4] = "\u65E5\u672C\u8A9E\u3092\u6559\u3048\u305F\u3044";
})(PurposeEnum || (PurposeEnum = {}));
export var DesiredConditionEnum;
(function (DesiredConditionEnum) {
    DesiredConditionEnum[DesiredConditionEnum["\u65E5\u672C\u8A9E\u304C\u5F97\u610F\u306A\u65B9\u304C\u3044\u3044"] = 1] = "\u65E5\u672C\u8A9E\u304C\u5F97\u610F\u306A\u65B9\u304C\u3044\u3044";
    DesiredConditionEnum[DesiredConditionEnum["\u65E5\u672C\u8A9E\u304C\u4E0D\u5F97\u610F\u3067\u3082\u69CB\u308F\u306A\u3044"] = 2] = "\u65E5\u672C\u8A9E\u304C\u4E0D\u5F97\u610F\u3067\u3082\u69CB\u308F\u306A\u3044";
})(DesiredConditionEnum || (DesiredConditionEnum = {}));
export var TutorialContentEnum;
(function (TutorialContentEnum) {
    TutorialContentEnum[TutorialContentEnum["general"] = 0] = "general";
    TutorialContentEnum[TutorialContentEnum["profile"] = 1] = "profile";
    TutorialContentEnum[TutorialContentEnum["reservation"] = 2] = "reservation";
    TutorialContentEnum[TutorialContentEnum["conversation"] = 3] = "conversation";
    TutorialContentEnum[TutorialContentEnum["encouragement"] = 4] = "encouragement";
    TutorialContentEnum[TutorialContentEnum["helpCenter"] = 5] = "helpCenter";
})(TutorialContentEnum || (TutorialContentEnum = {}));
